import { Box, Grid, Typography } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Close from "@material-ui/icons/Close";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import IconButton from "@mui/material/IconButton";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { downloadFile } from "src/app-redux/common-actions";
import { getAllFileCompressionConfigs } from "src/app-redux/configuration/actions/configurationActions";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  getWeightScanExistingDocuments,
  uploadVehicleWeightDocs,
} from "src/app-redux/vehicle/actions/vehicleActions";
import {
  currentSelectedIsNodWeightFile,
  currentSelectedVehicleRegNo,
  currentSelectedVehicleWeightId,
  loader as vehicleLoader,
} from "src/app-redux/vehicle/vehicleSlice";
import doc from "src/assets/images/file_formats_logos/doc.svg";
import img from "src/assets/images/file_formats_logos/img.svg";
import pdf from "src/assets/images/file_formats_logos/pdf.svg";
import xlsx from "src/assets/images/file_formats_logos/xlsx.svg";
import CommonButton from "src/components/CommonButton/CommonButton";
import { useStyles } from "./style";
import CommonLoader from "src/components/Loader/CommonLoader";

export interface IDrawerFilesProps {
  refreshDrawer: number;
}

export default function DrawerFiles(props: IDrawerFilesProps) {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const selectedVehicleWeightId: any = useAppSelector(currentSelectedVehicleWeightId);
  const selectedIsNodWeightFile: any = useAppSelector(currentSelectedIsNodWeightFile);
  const selectedVehicleRegNo: any = useAppSelector(currentSelectedVehicleRegNo);
  const loader2: any = useAppSelector(vehicleLoader);

  const [existingFiles, setexistingFiles] = React.useState<any[]>([]);

  const [fileToUpload, setFileToUpload] = React.useState<any[]>([]);
  const [validFileTypes, setValidFileTypes] = React.useState<any>([]);
  const [validFileSize, setValidFileSize] = React.useState(0);
  const [isValidFileType, setIsValidFileType] = React.useState<boolean[]>([]);
  const [isValidFileSize, setIsValidFileSize] = React.useState<boolean[]>([]);
  let fileTypesArr: any[] = [];
  let maxFileSize = 0;

  const onDrop = React.useCallback((acceptedFiles: File[]) => {
    const size: boolean[] = [];
    const type: boolean[] = [];

    acceptedFiles.forEach((file: any) => {
      const split = file.name.split(".");
      type.push(fileTypesArr.includes(`.${split[split.length - 1]}`.toLowerCase()));
      size.push(file.size / (1024 * 1024) <= maxFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
    setFileToUpload(acceptedFiles);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  useEffect(() => {
    getExistingDocs();
    getFileConfig();
  }, []);

  useEffect(() => {
    getExistingDocs();
  }, [props.refreshDrawer]);

  const getExistingDocs = async () => {
    const res: any = await dispatch(
      getWeightScanExistingDocuments({
        id: selectedVehicleWeightId,
        isScan: false,
        isNodWeightFile: selectedIsNodWeightFile,
      })
    );
    if (res?.payload?.length) {
      setexistingFiles(res.payload);
    }
  };

  const getFileConfig = async () => {
    const res: any = await dispatch(getAllFileCompressionConfigs());
    if (res.payload && res.payload[0]) {
      setValidFileTypes(res.payload[0].fileTypes.split(","));
      setValidFileSize(res.payload[0].fileSizeThreshold);
      fileTypesArr = res.payload[0].fileTypes.split(",");
      maxFileSize = res.payload[0].fileSizeThreshold;
    }
  };

  const formik = useFormik<any>({
    enableReinitialize: true,
    initialValues: {
      vehicleWeightId: selectedVehicleWeightId,
      registerationNumber: selectedVehicleRegNo,
    },
    onSubmit: async (values: any, actions) => {
      const form = new FormData();
      form.append("vehicleWeightId", values.vehicleWeightId);
      form.append("registerationNumber", values.registerationNumber);
      fileToUpload.length
        ? fileToUpload.forEach((file) => {
            form.append("files", file);
          })
        : form.append("files", "");

      const res: any = await dispatch(uploadVehicleWeightDocs(form));
      if (res.payload) {
        actions.setSubmitting(false);
        formik.resetForm();
        formik.setValues(formik.initialValues);
        setFileToUpload([]);
        setIsValidFileType([]);
        setIsValidFileSize([]);
        getExistingDocs();
        return;
      }
    },
  });

  const removeFileFromIndex = (index: number) => {
    const upload = fileToUpload;
    upload.splice(index, 1);
    setFileToUpload(upload);

    const size: boolean[] = [];
    const type: boolean[] = [];

    fileToUpload.forEach((file: any) => {
      const split = file.name.split(".");
      type.push(validFileTypes.includes(`.${split[split.length - 1]}`));
      size.push(file.size / (1024 * 1024) <= validFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
  };

  const downloadDocument = async (item: any) => {
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-doc-by-id/${item.id}?docType=3`,
      contentType: ".jpg",
      fileName: item.title,
    };
    dispatch(downloadFile(fileMetaData));
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader2}>
        <CommonLoader />
      </Backdrop>
      <div className={classes.drawerDetails}>
        {/* Drawer Status Item  */}

        <Grid container spacing={2} className="topContainer" style={{ marginTop: "5px" }}>
          <Grid container direction="row" className="itemRow" spacing={2}>
            {/* File Upload */}
            <Grid item xs={12} md={12}>
              <Box
                {...getRootProps()}
                p={0}
                pl={1}
                border={"1px solid #72CA00"}
                borderRadius={5}
                height={38}
                pb={4}
                overflow={"auto"}
                display={"flex"}
                flexWrap={"wrap"}
                borderColor={isDragActive ? "error.main" : "secondary.main"}
                style={{ cursor: "pointer" }}
              >
                <input {...getInputProps()} />

                {fileToUpload.length ? (
                  fileToUpload.map((file, index) => {
                    return (
                      <div
                        key={file.name}
                        style={{
                          marginTop: "6px",
                          backgroundColor: "#E67817",
                          padding: "3px 15px 3px 5px",
                          borderRadius: "10px",
                          maxWidth: "122px",
                          display: "flex",
                          flexWrap: "wrap",
                          marginLeft: "5px",
                        }}
                      >
                        <div
                          style={{
                            maxWidth: "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "11px",
                            color: "white",
                          }}
                        >
                          {file.name}
                        </div>
                        <IconButton
                          aria-label="Search"
                          onClick={(event) => {
                            event.stopPropagation();
                            removeFileFromIndex(index);
                          }}
                          edge="end"
                          className="icon-button-search"
                          style={{
                            color: "white",
                            padding: 0,
                            marginTop: "2px",
                            width: "10px",
                            height: "10px",
                            overflow: "hidden",
                            marginRight: "2px !important",
                          }}
                        >
                          <Close />
                        </IconButton>
                      </div>
                    );
                  })
                ) : isDragActive ? (
                  <p>Drop a file here ...</p>
                ) : (
                  <p style={{ color: "rgb(181 178 178)", marginTop: 9, paddingBottom: 10 }}>
                    {/* Drag and drop file here,or click to select a file */}
                    Upload File
                  </p>
                )}
              </Box>
              <Box>
                <p style={{ color: "#f44336", marginBottom: 0 }}>
                  <ul
                    style={{
                      paddingLeft: "16px",
                      margin: 0,
                      display: isValidFileType.includes(false) ? "block" : "none",
                    }}
                  >
                    <li>
                      Only{" "}
                      {validFileTypes.map((type: any, index: number) => {
                        return index < validFileTypes.length - 1 ? `${type},` : type;
                      })}{" "}
                      files are allowed.
                    </li>
                  </ul>
                  <ul
                    style={{
                      paddingLeft: "16px",
                      margin: 0,
                      display: isValidFileSize.includes(false) ? "block" : "none",
                    }}
                  >
                    <li>File size cannot exceed {validFileSize}MB.</li>
                  </ul>
                </p>
              </Box>
            </Grid>

            <Grid container item xs={12} md={12}>
              <Grid item xs={12} md={9}>
                <Box textAlign="left" mt={1}>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    onClick={() => {
                      formik.resetForm();
                      formik.setValues(formik.initialValues);
                      setFileToUpload([]);
                      setIsValidFileType([]);
                      setIsValidFileSize([]);
                    }}
                  >
                    Reset
                  </CommonButton>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    isGreen
                    disable={!isValidFileType || !isValidFileSize || !fileToUpload.length}
                    onClick={() => {
                      formik.submitForm();
                    }}
                  >
                    Save
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid container direction="row" className="itemRow" spacing={2}>
            <Grid
              item
              md={12}
              id="main-div"
              className={classes.drawerDetails}
              style={{
                height: "max-content",
              }}
            >
              <Grid container direction="row">
                {/* History Item  */}
                {existingFiles.length !== 0 ? (
                  existingFiles.map((item: any) => (
                    <Grid md={6} key={item.id} style={{ padding: "5px" }}>
                      <Grid container direction="row" className="itemRowTrail">
                        <Grid md={3} style={{ padding: "5px" }}>
                          <img
                            src={
                              item.extension === "doc" || item.extension === "docx"
                                ? doc
                                : item.extension === "jpg" ||
                                  item.extension === "jpeg" ||
                                  item.extension === "png"
                                ? img
                                : item.extension === "pdf"
                                ? pdf
                                : item.extension === "xlsx"
                                ? xlsx
                                : img
                            }
                            alt={item.extension}
                            width="25px"
                          />
                        </Grid>
                        <Grid md={6}>
                          <Typography className="subHeading itemName">
                            {item.originalFileName}
                          </Typography>
                        </Grid>
                        <Grid md={2}>
                          <IconButton
                            onClick={() => {
                              downloadDocument(item);
                            }}
                          >
                            <CloudDownloadIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <div></div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
